import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",

    // position: "absolute",
    // bottom: "10px",
    // left: "0",
    // right: "0",
    // display: "flex",
    // justifyContent: "flex-end",
    // padding: theme.spacing(0, 2),
  },
  content: {
    flexGrow: 1,
  },
  okButton: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
  subtitle: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export default function InvitationSentScreen({ setInviteDrawer, profileData }) {
  const classes = useStyles();

  const handleOk = () => {
    // handleRefresh();
    setInviteDrawer(false);
  };
  return (
    <Box style={{ marginTop: "8px" }} className={classes.container}>
      <Box className={classes.content}>
        <Typography
          style={{ display: "flex", fontSize: "16px"}}
          gutterBottom
        >
          Invitation Sent Successfully
          <CheckCircleIcon style={{ color: "green" }} />
        </Typography>
        <Typography className={classes.subtitle}>Full Name</Typography>
        <Typography>{profileData?.name}</Typography>
        <Typography className={classes.subtitle}>Email</Typography>
        <Typography>{profileData?.email}</Typography>
        <Typography className={classes.subtitle}>Employee Number</Typography>
        <Typography>{profileData?.employeeNumber || "NA"}</Typography>
        <Typography className={classes.subtitle}>Department - Role</Typography>
        <Typography>{profileData?.role}</Typography>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button onClick={handleOk} size="small" className={classes.okButton}>
          Ok
        </Button>
      </Box>
    </Box>
  );
}
